import { gql } from "@apollo/client";

export default gql`
  query getMobileAppVersionConfigs{
    getMobileAppVersionConfigs{
        success
        data{
            _id
            platform
            latestVersion
            minSupportedVersion
            updateType
            storeUrl
            releaseNotes{
                tr{
                    title
                    body
                }
                en{
                    title
                    body
                }
                ar{
                    title
                    body
                }
            }
            updatedBy
            createdAt
            updatedAt
        }
        error
        message
    }
}
`
